/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React, { useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { CharactersLenghtAtom } from "../../atoms/CharactersLenghtAtom";
import { WordsLengthAtom } from "../../atoms/WordsLengthAtom";
import { notSelect } from "../../styles/general";
import { Option } from "../../types/SavedSearchTypes";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  position: relative;

  margin: 0;

  ${notSelect}
  flex-shrink: 0;
`;

const CounterInput = styled.div`
  font: normal normal 600 15px "Source Sans Pro";
  color: #555555;
  cursor: pointer;
`;

export default function WordSelect(): JSX.Element {
  const [characters] = useRecoilState(CharactersLenghtAtom);
  const words = useRecoilValue(WordsLengthAtom);
  const [options] = useState<Option[]>([
    { name: "Word", id: "1" },
    { name: "Character", id: "2" },
  ]);
  const [selectedOption, setSelectedOption] = useState<Option>({
    name: "Word",
    id: "1",
  });

  function wordsOrCharacters() {
    if (selectedOption.name === options[0].name) setSelectedOption(options[1]);
    else setSelectedOption(options[0]);
  }

  return (
    <Container>
      <CounterInput onClick={() => wordsOrCharacters()}>
        {selectedOption.name === options[0].name
          ? `${words} ${selectedOption.name}${words !== 1 ? "s" : ""}`
          : `${characters} ${selectedOption.name}${
              characters !== 1 ? "s" : ""
            }`}
      </CounterInput>
    </Container>
  );
}
